module.exports = __webpack_public_path__ + "img/icon-readaloud-2.36d114cf.svg";